const get_started = {
    page_title: 'Get started',
    title: 'Something to help you succeed',
    subtitle: 'A few things you can do to quickly get value of Cast Identity',
    develop: {
        title: 'Develop: Take 5 minutes to integrate your app',
        title_cloud: 'Develop: Securely integrate your app in minutes',
        subtitle_cloud: 'Or take 5 minutes to integrate your app with our pre-built SDKs and tutorials.',
        try_mcp: 'Try one-prompt integration with MCP',
    },
    customize: {
        title: 'Customize: Deliver a great sign-in experience',
        preview: {
            title: 'Check the live preview of the sign-in experience you just customized',
            subtitle: 'Try Cast Identity sign-in experience now to see how it works',
        },
        connector: {
            title: 'Add more connectors to support more social sign-in methods',
            subtitle: 'Try passwordless sign in and enable a secure and frictionless experience for your customers',
        },
        continue_customizing: 'Continue customizing',
        try_now: 'Try now',
        add_more: 'Add more',
    },
    secure: {
        title: 'Secure: Protect your resources',
    },
    manage: {
        title: 'Manage: Define access control for your product and users',
        rbac: {
            title: 'Add role-based access control to protect your resources',
            subtitle: 'Control your resource through scalable role authorization for diverse use cases.',
        },
        create_roles: 'Create roles',
    },
    convert_to_production: {
        card_title: 'Ready to go live? Don’t forget to launch your production setup!',
        title: "Don't keep your project stuck in dev mode",
        subtitle: "You're using a dev tenant for free testing. To go live, create or convert to a production tenant. Need something custom? <a>Contact us</a>",
        convert_button: 'Convert to production tenant',
    },
    view_all: 'View all →',
};
export default Object.freeze(get_started);
